import { useMemo } from "react"
import { useApi } from "./api";

export function useClientConfig(filters: object) {
  const queryString = Object.entries(filters)
    .map((query) => {
      //Join all query keys values with ','
      const values = query[1]
      //add these values to name of the query
      return query[0] + "=" + values
    })
    .join("&") //join fi
  const [response, error, loading, retry] = useApi(`/MobileClientConfigurations`+`?${queryString}`)
  const data = useMemo(() => response?.data?.array ?? [], [response?.data?.array])
  return useMemo(() => [data, error, loading, retry], [data, error, loading, retry])
}
export interface ClientConfig {
  "login": {
    "logo": string
  },
  "header": {
    "backgroundColor": string ,
    "titleColor": string ,
    "logo": string
  },
  "filter": {
    "filterPlayerAllColor": string ,
    "filterPlayerOfflineColor": string ,
    "filterPlayerOnlineColor": string ,
  },
  "global": {
    "backgroundColor": string ,
    "titleColor": string ,
    "textColor": string ,
    "fontFamily": string,
    "urlFont": string
  },
  "button": {
    "color": string ,
    "textColor": string ,
    "selectedColor": string ,
    "selectedTextColor": string
  }
}
